var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72058 0.0823529C5.56176 0.147059 5.42647 0.247059 5.32059 0.376471L0.308824 5.38824C-0.102941 5.8 -0.102941 6.45882 0.308824 6.87059C0.714707 7.28235 1.37941 7.28235 1.79117 6.87059L5.05589 3.60588L5.05 11.9529C5.05 12.5294 5.52059 13 6.09706 13C6.67353 13 7.14412 12.5294 7.14412 11.9529L7.15001 3.54706L10.4677 6.87059C10.8735 7.28235 11.5383 7.28235 11.95 6.87059C12.1559 6.66471 12.2559 6.4 12.2559 6.12941C12.2559 5.86471 12.1559 5.59412 11.95 5.38824L6.87354 0.305882C6.67942 0.111765 6.40883 0 6.13235 0C5.9853 0 5.84999 0.0294118 5.72058 0.0823529Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.249d54d1.svg";
export { ForwardRef as ReactComponent };